/**
 * Identifying a patient's medication.
 *
 * This package used to reach RxNorm from the device to guess at a drug from a
 * typed name. It no longer does: RxNorm knows US clinical drugs, not the pack
 * a patient in France is holding, and a guess made on the device could not be
 * checked against anything. The catalog below answers in packs, per country,
 * from the server that will store the answer.
 */
export {
  MedicationPackPhotoError,
  describeError,
  canPhotographPackCode,
  preparePackPhoto,
  medicationCatalogKeys,
  useMedicationProductVariations,
  useMedicationQuickAdd,
  useResolveMedicationPackCode,
  useResolveMedicationPackPhoto,
  usePackPhotoScan,
} from "./catalog";
export type { MedicationQuickAddItem } from "./catalog";
export type { PackPhotoFailure, PackPhotoStage } from "./catalog";
export {
  buildMedicationIdentityInput,
  createMedicationIdentityDraft,
  inferPatientMedicationForm,
  isFilledFromScan,
  matchTypedProduct,
  resolveCatalogProductName,
  normalizeProductName,
  withProductName,
} from "./catalog";
export type { MedicationIdentityDraft } from "./catalog";
export type {
  MedicationCatalogProduct,
  MedicationCodeResolution,
  MedicationIdentityInput,
  MedicationIdentitySource,
  MedicationPackPresentation,
  MedicationProductDimensions,
} from "./catalog";

// From #3825, and not the add-medication form's: the document vault resolves
// a medication from text it has just extracted, under its own deadline.
export {
  findMedicationByName,
  resolveMedicationCatalogId,
  withMedicationLookupDeadline,
} from "./catalog";
export type { MedicationCatalogItem } from "./catalog";
